import { render, staticRenderFns } from "./suspensionCenter.vue?vue&type=template&id=7bae2136&scoped=true"
import script from "./suspensionCenter.vue?vue&type=script&lang=js"
export * from "./suspensionCenter.vue?vue&type=script&lang=js"
import style0 from "./suspensionCenter.vue?vue&type=style&index=0&id=7bae2136&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bae2136",
  null
  
)

export default component.exports